/**
 * growthProductionGuard.js
 *
 * Centralized utility to detect whether the application is running in the
 * growth.vin production environment.
 *
 * Guarantees zero side-effects on staging (asiyapp.com, staging-growth.vin, localhost).
 */

export function isGrowthProduction() {
  return false;
}
